import { VOICE_WS_METHODS } from "@t3tools/contracts";
import { Atom } from "effect/unstable/reactivity";

import type { EnvironmentRegistry } from "../connection/registry.ts";
import {
  createAtomCommandScheduler,
  createEnvironmentRpcCommand,
  createEnvironmentRpcStreamCommand,
  createEnvironmentRpcSubscriptionAtomFamily,
} from "./runtime.ts";

export type {
  VoiceConversationAppendAudioInput,
  VoiceConversationEndInputInput,
  VoiceConversationEventsInput,
  VoiceConversationStartInput,
  VoiceConversationStopInput,
  VoiceSynthesizeSpeechInput,
  VoiceTranscribeClipInput,
} from "@t3tools/contracts";

export function createEnvironmentVoiceAtoms<R, E>(
  runtime: Atom.AtomRuntime<EnvironmentRegistry | R, E>,
) {
  const scheduler = createAtomCommandScheduler();
  const concurrency = {
    mode: "serial" as const,
    key: ({ environmentId }: { environmentId: string }) => environmentId,
  };

  return {
    transcribeClip: createEnvironmentRpcCommand(runtime, {
      label: "environment-data:voice:transcribe-clip",
      tag: VOICE_WS_METHODS.transcribeClip,
      scheduler,
      concurrency,
    }),
    synthesizeSpeech: createEnvironmentRpcStreamCommand(runtime, {
      label: "environment-data:voice:synthesize-speech",
      tag: VOICE_WS_METHODS.synthesizeSpeech,
      scheduler,
      concurrency,
    }),
    startConversation: createEnvironmentRpcCommand(runtime, {
      label: "environment-data:voice:conversation-start",
      tag: VOICE_WS_METHODS.conversationStart,
      scheduler,
      concurrency,
    }),
    appendConversationAudio: createEnvironmentRpcCommand(runtime, {
      label: "environment-data:voice:conversation-append-audio",
      tag: VOICE_WS_METHODS.conversationAppendAudio,
      scheduler,
      concurrency,
    }),
    endConversationInput: createEnvironmentRpcCommand(runtime, {
      label: "environment-data:voice:conversation-end-input",
      tag: VOICE_WS_METHODS.conversationEndInput,
      scheduler,
      concurrency,
    }),
    stopConversation: createEnvironmentRpcCommand(runtime, {
      label: "environment-data:voice:conversation-stop",
      tag: VOICE_WS_METHODS.conversationStop,
      scheduler,
      concurrency,
    }),
    conversationEvents: createEnvironmentRpcSubscriptionAtomFamily(runtime, {
      label: "environment-data:voice:conversation-events",
      tag: VOICE_WS_METHODS.conversationEvents,
    }),
  };
}
